import React, { useEffect } from "react";
import DashboardLayout from "../../components/layouts/DashboardLayout";
// import Link from 'next/link';
import { Container, Col, Row } from "react-bootstrap";

// import widget/custom components
import StatRightTopIcon from "../../components/utils/StatRightTopIcon";

// import sub components
// import { ActiveProjects, Teams, TasksPerformance } from "./"
import ActiveProjects from "../../components/utils/LeadListDashboard";
// import required data files
import { DashboardCardOperator } from "../../components/utils/ProjectsStatsData";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardAction } from "../../services/action/common";
import { handlePopupModalAction } from "../../services/action/event";
import { Menu } from "lucide-react";
const OperatorDashboard = () => {
  const dispatch = useDispatch();
  const { dashboardData } = useSelector((state) => state.commonReducer);
  useEffect(() => {
    dispatch(getDashboardAction({ userType: "operator" }));
  }, []);
  return (
    <DashboardLayout>
      <div
        className=" pt-10 pb-21"
        style={{ backgroundColor: "#00234a" }}
      ></div>

      <Container fluid className="mt-n22 px-6">
        <button
          onClick={() =>
            dispatch(handlePopupModalAction({ isOpenSidebar: true }))
          }
          className="mr-4 p-2 hover:text-[#fff]  rounded-md hover:bg-[#0A2547] lg:hidden"
        >
          <Menu className="w-6 h-6" />
        </button>
        <Row>
          <Col lg={12} md={12} xs={12}></Col>
          {DashboardCardOperator(dashboardData)?.map((item, index) => {
            return (
              <Col xl={3} lg={6} md={12} xs={12} className="mt-6" key={index}>
                <StatRightTopIcon info={item} />
              </Col>
            );
          })}
        </Row>

        {/* Active Projects  */}
        <ActiveProjects data={dashboardData?.leadList} pageTitile="Order" />
      </Container>
    </DashboardLayout>
  );
};

export default OperatorDashboard;
